const state = () => ({
    // single reactive source of truth; lookups are derived in getters
    assetList: [],
})


const getters = {
    getAssetBySymbol: (state) => {
        const bySymbol = new Map(state.assetList.map(asset => [asset.symbol, asset]));
        return (symbol) => bySymbol.get(symbol);
    },
    getAssetByPublicId: (state) => {
        const byPublicId = new Map(state.assetList.map(asset => [asset.public_id, asset]));
        return (assetPublicId) => byPublicId.get(assetPublicId);
    },
    getAssetMapper: (state) => {
        const mapper = {};
        for (const asset of state.assetList) mapper[asset.symbol] = asset;
        return mapper;
    },
    assetSymbolList: (state) => {
        return state.assetList.filter(asset => asset.status !== 'disabled').map(asset => asset.symbol).sort();
    },
}

const actions = {
    updateAssets(context, assetList) {
        for (let i = 0; i < assetList.length; i++) {
            context.commit('updateAsset', assetList[i]);
        }
    },
}

const mutations = {
    updateAsset(state, asset) {
        // frozen: whole-reference replacement is the only update path, never in-place
        const frozen = Object.freeze(asset);
        for (let i = 0; i < state.assetList.length; i++) {
            if (state.assetList[i].symbol === frozen.symbol) {
                state.assetList.splice(i, 1, frozen);
                return;
            }
        }
        state.assetList.push(frozen);
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
